import React from 'react';
import { Page } from './Page';
import SphereLogo from '../../media/sphereFullLogo.png';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const ReportTitlePage: React.FC<{ title: string; subtitle: string }> = ({ title, subtitle }) => {
  return (
    <React.Fragment>
      <Page>
        <img src={SphereLogo} style={{ width: '7cm' }} alt="" />
        <Stack
          sx={{
            flexGrow: 1,
            gap: '3cm',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography sx={{ fontSize: '3.5rem' }}>{title}</Typography>
          <Typography sx={{ fontSize: '1.5rem' }}>{subtitle}</Typography>
        </Stack>
      </Page>
    </React.Fragment>
  );
};

export default ReportTitlePage;
